import React, { useEffect } from 'react';
import './DoctorProfile.css';
import { Award, GraduationCap, Heart, Sparkles, Stethoscope, Users } from 'lucide-react';
import { FloatingWhatsApp } from "react-floating-whatsapp";
import {whatsAppBotListener } from "../../utils/Utils";
import { PHONE_NUMBER } from "../../utils/Constant";
import clinicIcon from '../../assets/ivory/DenviaLogo.png';


// Replace with actual doctor image
import doctorImage from '../../assets/newGalleryPics/profileImageResized.jpg';

const DoctorProfile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const qualifications = [
  { degree: 'BDS', title: 'Bachelor of Dental Surgery' },
  { degree: 'FDS', title: 'Fellowship in Dental Surgery <br /> ( Prosthodontics and Implantology )' },
  { degree: 'FPFA (USA)', title: 'Fellowship from Pierre Fauchard Academy' },
];


  const expertise = [
    { icon: <Award size={28} />, title: 'Prosthodontics', description: 'Crowns, Bridges and full mouth rehabilitation' },
    { icon: <Stethoscope size={28} />, title: 'Implantology', description: 'Advanced dental implant procedures' },
    { icon: <Sparkles size={28} />, title: 'Aesthetic Dentistry', description: 'Smile makeover and cosmetic dentistry' },
    { icon: <Heart size={28} />, title: 'Patient Care', description: 'Compassionate and personalized treatment' }
  ];

  const journey = [
    { year: 'Education', title: 'Bachelor of Dental Surgery (BDS)', description: 'Completed dental education with excellence' },
    { year: 'Fellowship', title: 'FDS', description: '( Prosthodontics & Implantology ) mastered smile restoration and implant procedures' },
    { year: 'Specialization', title: 'Prosthodontics & Implantology', description: ' Advance training ( FPFA ) ' },
    { year: 'Foundation', title: 'Founder of Denvia Multispeciality Dental Clinic', description: 'Established state-of-the-art facility in Jaipur' }
  ];

  return (
    <section className="doctor-profile-section">
      {/* Hero Section */}
      <div className="doctor-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text" data-aos="fade-right">
              <span className="hero-label">MEET OUR CLINIC DIRECTOR</span>
              <h1 className="hero-title">DR. ADITYA JAIN</h1>
              <div className="hero-credentials">
                <span className="credential">BDS, FDS</span>
                <span className="credential">FPFA (USA)</span>
                {/* <span className="credential">FICOI (USA)</span> */}
              </div>
              <p className="hero-designation">PROSTHODONTIST AND IMPLANTOLOGIST</p>
            </div>
            <div className="hero-image" data-aos="fade-left">
              <div className="image-wrapper">
                <img src={doctorImage} alt="Dr. Aditya Jain" />
                <div className="image-decoration"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="doctor-about">
        <div className="container">
          <div className="about-content" data-aos="fade-up">
            <h2 className="section-title">About Dr. Aditya Jain</h2>
            <div className="about-text">
              <p>
                Dr. Aditya Jain is a highly skilled Prosthodontist and Implantologist and the founder of Denvia
                Multispeciality Dental Clinic, Jaipur. He is dedicated to helping patients achieve healthy,
                functional, and confident smiles through personalized, high-quality dental care.
              </p>
              <p>
                With advanced training in prosthodontics and dental implantology, Dr. Aditya  has a deep
                understanding of restoring and enhancing smiles—whether through full-mouth rehabilitation,
                dental implants, or aesthetic restorations. His approach combines clinical precision with genuine
                compassion, ensuring that every patient feels comfortable and well-informed throughout their
                treatment journey.
              </p>
            </div>
          </div>
        </div>
      </div>

{/* Qualifications */}
      <div className="doctor-qualifications">
  <div className="container">
    <h2 className="section-title" data-aos="fade-up">Qualifications & Credentials</h2>
    <div className="qualifications-grid">
      {qualifications.map((qual, index) => (
        <div 
          key={index} 
          className="qualification-card"
          data-aos="zoom-in"
          data-aos-delay={index * 100}
        >
          <GraduationCap className="qual-icon" size={40} />
          <h3 className="qual-degree">{qual.degree}</h3>

          {/* ⬇️ Updated to allow <br /> line break */}
          <p 
            className="qual-title" 
            dangerouslySetInnerHTML={{ __html: qual.title }}
          />
        </div>
      ))}
    </div>
  </div>
      </div>


      {/* Expertise Areas */}
      <div className="doctor-expertise">
        <div className="container">
          <h2 className="section-title" data-aos="fade-up">Areas of Expertise</h2>
          <div className="expertise-grid">
            {expertise.map((item, index) => (
              <div 
                key={index} 
                className="expertise-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="expertise-icon">{item.icon}</div>
                <h3 className="expertise-title">{item.title}</h3>
                <p className="expertise-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Journey Timeline */}
      <div className="doctor-journey">
        <div className="container">
          <h2 className="section-title" data-aos="fade-up">Professional Journey</h2>
          <div className="timeline">
            {journey.map((milestone, index) => (
              <div 
                key={index} 
                className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
                data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
                data-aos-delay={index * 100}
              >
                <div className="timeline-content">
                  <div className="timeline-year">{milestone.year}</div>
                  <h3 className="timeline-title">{milestone.title}</h3>
                  <p className="timeline-description">{milestone.description}</p>
                </div>
                <div className="timeline-dot"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Philosophy Section */}
      <div className="doctor-philosophy">
        <div className="container">
          <div className="philosophy-content" data-aos="fade-up">
            <Users className="philosophy-icon" size={48} />
            <h2 className="philosophy-title">Our Philosophy</h2>
            <div className="philosophy-text">
              <p>
                Dr. Aditya believes in the power of continuous learning and keeps himself updated with the latest
                advancements in dental materials, techniques, and technologies. This commitment allows him
                to offer his patients modern, evidence-based solutions with long-lasting results.
              </p>
              <p>
                Known for his calm and reassuring demeanor, Dr. Aditya takes the time to listen to each patient's
                needs and design customized treatment plans that align with their goals. His philosophy centers
                on building lasting relationships based on trust, transparency, and exceptional care.
              </p>
            </div>
            <div className="philosophy-cta">
              <p className="cta-text">
                At Denvia Multispeciality Dental Clinic, Dr. Aditya Jain and his team strive to create a positive
                and comfortable dental experience for every patient—helping you smile with confidence, today
                and for years to come.
              </p>
            </div>
          </div>
        </div>
      </div>
            {/* What's app bot section */}
                  <FloatingWhatsApp
                      avatar={clinicIcon}
                      notification={false}
                      accountName="Denvia Dental Clinic"
                      phoneNumber={PHONE_NUMBER}
                      onSubmit={(e) => {
                          whatsAppBotListener(e.target[0].value);
                      }}
            />
    </section>
  );
};

export default DoctorProfile;
